import { CommonMessage } from '@frontend/lang';
import { FormattedMessage, useIntl } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import useCreateReceiver from './create-receiver.controller';

const ID = 'create-receiver';

const CreateReceiver = () => {
    const intl = useIntl();
    const viewProps = useCreateReceiver();
    const emailPlaceholder = viewProps.domain
        ? intl.formatMessage({
              id: 'kiosk.wizard.create-receiver.email-local-part-placeholder',
              description: 'Placeholder for the receiver email local-part input when the domain is fixed',
              defaultMessage: 'name'
          })
        : intl.formatMessage({
              id: 'kiosk.wizard.create-receiver.email-placeholder',
              description: 'Placeholder for the receiver email input when no fixed domain is configured',
              defaultMessage: 'name@example.com'
          });

    return (
        <WizardScreenContainer
            id={ID}
            header={{ title: CommonMessage.BUTTONS.DROP_OFF }}
            footer={{
                onBack: viewProps.onBack,
                onSubmit: viewProps.onSubmit,
                submitDisabled: viewProps.submitDisabled
            }}
            loadingModal={{ show: viewProps.isLoadingSettings || viewProps.isSubmitting }}
            errorModal={{
                show: !!viewProps.error,
                title: CommonMessage.ERRORS.DEFAULT,
                message: viewProps.error,
                onClose: viewProps.resetError
            }}
            containerClassName='bg-background-default flex flex-1 flex-col items-start justify-start gap-4 self-stretch overflow-y-auto px-5 pt-6 pb-20'>
            <div className='text-foreground-default justify-start text-base font-medium'>
                <FormattedMessage
                    id='kiosk.wizard.create-receiver.instructions'
                    description='Instructions shown on the screen where a kiosk user creates a transaction receiver'
                    defaultMessage='Enter the receiver email address.'
                />
            </div>

            <div className='flex h-auto w-full flex-col items-start justify-start gap-1'>
                <div className='mb-0! flex w-full flex-col'>
                    <div className='flex justify-between'>
                        <label
                            htmlFor='create-receiver-email'
                            className='text-foreground-default text-sm font-medium'>
                            {CommonMessage.FORMS.EMAIL()}
                        </label>
                    </div>
                </div>

                <div className='inline-flex h-full w-full flex-row items-start justify-start self-stretch'>
                    <div
                        className={`bg-background-surface outline-border-default flex h-11 w-full flex-1 items-center justify-start gap-2 overflow-hidden rounded-xl outline-1 outline-offset-[-1px] ${
                            viewProps.isLoadingSettings || viewProps.isSubmitting ? 'opacity-60' : ''
                        }`}>
                        <input
                            id='create-receiver-email'
                            data-testid='create-receiver-email'
                            className='form-control text-foreground-default min-w-0 flex-1 border-none text-base font-medium outline-none'
                            value={viewProps.emailInput}
                            onChange={(event) => viewProps.setEmailInput(event.target.value)}
                            inputMode='email'
                            autoCapitalize='none'
                            autoCorrect='off'
                            disabled={viewProps.isLoadingSettings || viewProps.isSubmitting}
                            placeholder={emailPlaceholder}
                        />

                        {viewProps.domain && (
                            <div className='border-border-default text-brand-muted flex h-full max-w-[45%] shrink-0 items-center border-l px-4 text-base font-medium'>
                                <span className='truncate'>
                                    <FormattedMessage
                                        id='kiosk.wizard.create-receiver.fixed-domain'
                                        description='Readonly domain suffix shown inline in the receiver email input'
                                        defaultMessage='@{domain}'
                                        values={{ domain: viewProps.domain }}
                                    />
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </WizardScreenContainer>
    );
};

export default CreateReceiver;
